export default {
  iconsPath: {}
}



// WEBPACK FOOTER //
// ./src/shared.js